import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import Navigation from '../../../Shared/Navigation/Navigation';

const ProjectDetail = (props) => {
    const { name, livesite_link, clientCode, serverCode, img1, img2, img3, description, technology } = props.project;
    return (
        <>
            <Navigation></Navigation>
            <div className="pt-5">
                <Container>
                    <Row>
                        <Col className=" text-start bg-opacity-25">
                            <h2 className="py-5 project-title">{name}</h2>
                            <p><span className="fs-5 fw-bold">Description: </span><br /><br />{description}</p>

                            <p><span className="fs-5 fw-bold">Technologies: </span><br /><br />{technology}</p>

                            <p className="fs-5 fw-bold">Links: </p>


                            <a href={livesite_link} target="blank" className="text-decoration-none text-dark fw-bold">
                                <Button variant="success" className="m-1 ">
                                    Live Site
                                </Button>
                            </a>
                            <a href={clientCode} target="blank" className="text-decoration-none text-dark fw-bold">
                                <Button variant="success" className="m-1 ">
                                    Client Code
                                </Button>
                            </a>
                            {props.project.serverCode && <a href={serverCode} target="blank" className="text-decoration-none text-dark fw-bold">
                                <Button variant="success" className="m-1 ">
                                    Server Code
                                </Button>
                            </a>}
                        </Col>

                        <Col md={6}>
                            <Row>
                                <Col md={6}>
                                    <img className="img-fluid mb-2" src={img1} alt="" />
                                </Col>

                                <Col md={6}>
                                    <img className="img-fluid mb-2" src={img2} alt="" style={{ height: "241px" }} />
                                    <img className="img-fluid" src={img3} alt="" style={{ height: "241px" }} />
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div >
        </>
    );
};

export default ProjectDetail;